import React from 'react';
import { Link } from 'react-router-dom';

const FAQs = () => {
  return (
    <div className="d-flex flex-column min-vh-100" style={{ background: '#1f2028' }}>
      {/* Navigation Bar */}
      <div style={{ position: 'sticky', top: 0, zIndex: 1000, backgroundColor: '#1f2028', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
        <div className="container-fluid px-3">
          <div className="d-flex align-items-center justify-content-between py-2" style={{ height: '48px' }}>
            {/* Logo/Brand */}
            <div>
              <Link to="/" className="text-decoration-none">
                <h5 className="text-light mb-0 fw-bold" style={{ fontSize: '1.1rem' }}>RE Calc</h5>
              </Link>
            </div>
            
            {/* Navigation Links */}
            <div>
              <Link to="/features" className="btn btn-link text-light text-decoration-none">Features</Link>
              <Link to="/faqs" className="btn btn-link text-light text-decoration-none">FAQs</Link>
              <Link to="/contact" className="btn btn-link text-light text-decoration-none">Get in Touch</Link>
              <Link to="/pricing" className="btn btn-link text-light text-decoration-none">Pricing</Link>
              <Link to="/signup" className="btn btn-primary btn-sm ms-3">Ready to Start?</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container py-5">
        <h1 className="text-white mb-4">Frequently Asked Questions</h1>
        
        <div className="accordion" id="faqAccordion">
          <div className="accordion-item bg-dark border-secondary mb-3">
            <h2 className="accordion-header" id="headingOne">
              <button className="accordion-button bg-dark text-white" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                What is RE Calc?
              </button>
            </h2>
            <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#faqAccordion">
              <div className="accordion-body text-light">
                RE Calc is a comprehensive real estate investment calculator that helps investors analyze properties, calculate returns, and make data-driven investment decisions. Our platform provides tools for property analysis, scenario comparison, and portfolio management.
              </div>
            </div>
          </div>
          
          <div className="accordion-item bg-dark border-secondary mb-3">
            <h2 className="accordion-header" id="headingTwo">
              <button className="accordion-button bg-dark text-white collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                Is RE Calc free to use?
              </button>
            </h2>
            <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#faqAccordion">
              <div className="accordion-body text-light">
                RE Calc offers both free and premium plans. The free plan includes basic property analysis tools, while our premium plans offer advanced features like scenario comparison, portfolio management, and customizable settings. Check our <Link to="/pricing" className="text-primary">pricing page</Link> for more details.
              </div>
            </div>
          </div>
          
          <div className="accordion-item bg-dark border-secondary mb-3">
            <h2 className="accordion-header" id="headingThree">
              <button className="accordion-button bg-dark text-white collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                How accurate are the calculations?
              </button>
            </h2>
            <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#faqAccordion">
              <div className="accordion-body text-light">
                RE Calc uses industry-standard formulas and methodologies for all calculations. The accuracy of the results depends on the quality of the input data. We provide customizable settings to help you tailor the calculations to your specific market and investment strategy.
              </div>
            </div>
          </div>
          
          <div className="accordion-item bg-dark border-secondary mb-3">
            <h2 className="accordion-header" id="headingFour">
              <button className="accordion-button bg-dark text-white collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                Can I analyze both long-term and short-term rentals?
              </button>
            </h2>
            <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#faqAccordion">
              <div className="accordion-body text-light">
                Yes! RE Calc supports analysis for both long-term and short-term rental strategies. You can create different scenarios for each property to compare these strategies and determine which one offers the best returns for your investment.
              </div>
            </div>
          </div>
          
          <div className="accordion-item bg-dark border-secondary mb-3">
            <h2 className="accordion-header" id="headingFive">
              <button className="accordion-button bg-dark text-white collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                How do I get started?
              </button>
            </h2>
            <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#faqAccordion">
              <div className="accordion-body text-light">
                Getting started is easy! Simply <Link to="/signup" className="text-primary">create a free account</Link>, and you'll be able to start analyzing properties right away. We also provide tutorials and guides to help you make the most of our platform.
              </div>
            </div>
          </div>
        </div>
        
        <div className="text-center mt-5">
          <p className="text-light mb-4">Don't see your question here?</p>
          <Link to="/contact" className="btn btn-outline-light me-3">Contact Us</Link>
          <Link to="/signup" className="btn btn-primary">Get Started Now</Link>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="py-4 mt-auto" style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <p className="text-muted mb-0 small">© 2025 RE Calc. All rights reserved.</p>
            <div>
              <Link to="/login" className="text-muted me-3 small">Login</Link>
              <Link to="/signup" className="text-muted small">Sign Up</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default FAQs;
